import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { ChevronDown, ChevronRight } from '@gravity-ui/icons';

import styles from './MenuMobile.module.scss';

interface Props {
    to: string;
    text?: ReactNode;
    isCurrent?: boolean;
}

export const LinkMobile: FC<Props> = ({ to, text = ' ', isCurrent }) => (
    <Link key={to} className={styles.navLinkMobile} to={to}>
        {isCurrent ? <ChevronDown /> : <ChevronRight />}
        {text}
    </Link>
);
